// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { FillableDataCacheTool } from "./FillableDataCacheTool.js";

export let EllipseDataCacheTool = function ()
{
    FillableDataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.Ellipse;
    this.InitPoints(83);
};

EllipseDataCacheTool.prototype = Object.create(FillableDataCacheTool.prototype);

Object.defineProperty(EllipseDataCacheTool.prototype, 'Scale', {
    get: function ()
    {
        var pts = this.Points;

        var p0 = pts[0];
        var x0 = p0[0];
        var y0 = p0[1];

        var p1 = pts[1];
        var x1 = p1[0];
        var y1 = p1[1];

        var p2 = pts[2];
        var x2 = p2[0];
        var y2 = p2[1];

        var sqrt = Math.sqrt(
            (Math.pow(x1 - x0           , 2) + Math.pow(y1 - y0           , 2)) /
            (Math.pow(x2 - (x0 + x1) / 2, 2) + Math.pow(y2 - (y0 + y1) / 2, 2)));

        return sqrt / 2;
    },

    set: function (value)
    {
        var pts = this.Points;

        var p0 = pts[0];
        var x0 = p0[0];
        var y0 = p0[1];

        var p1 = pts[1];
        var x1 = p1[0];
        var y1 = p1[1];

        var p2 = pts[2];

        var ax = x1 - x0;
        var ay = y1 - y0;

        var by = Math.sqrt((ax * ax + ay * ay) / (4 * value * value * (1 + ay * ay / ax / ax)));
        var bx = -ay * by / ax;

        p2[0] = bx + (x0 + x1) / 2;
        p2[1] = by + (y0 + y1) / 2;
    }
});

EllipseDataCacheTool.prototype.MinPointsCount = function () { return 3; }
EllipseDataCacheTool.prototype.MaxPointsCount = function () { return 3; }
EllipseDataCacheTool.prototype.AdditionalPointsCount = function () {  return 80; }